<template>
  <b-modal id="event-modal" :title="title" v-model="showModal" centered   :hide-footer="true" size="lg">
    <div id="background" class="col-12" >
      <a v-if="link" :href="link">
        <b-img :src="img" fluid></b-img>
      </a>
      <b-img v-else :src="img" fluid></b-img>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: "EventModal",
    props: {
      img: {type: String, default: 'static/image/covid/quvestraCovid.jpg'},
      title: {type: String, default: 'Prevenzione Covid-19'},
      link: {type: String, default: ''}
    },

    data() {
      return {
        showModal: true
      }
    },
    methods: {
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/variabili.less";
  @import "../../assets/less/font.less";

  #event-modal {
    #event-modal___BV_modal_header_{
      padding: 4px;
      .set-font(@size: 10px, @color: black);
      background-color: #202127;
      color: white;
      border: none;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    .close{
      color:white;
    }
    #event-modal___BV_modal_body_ {
      padding:0;

      #background {
        padding:0;
        background-size: contain;
        background-repeat: no-repeat;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/global/EventModal.vue